import React from 'react';
interface WaveDividerProps {
  position?: 'top' | 'bottom';
  color?: string;
  className?: string;
  flip?: boolean;
}
export function WaveDivider({
  position = 'bottom',
  color = '#FFFFFF',
  className = '',
  flip = false
}: WaveDividerProps) {
  return <div className={`w-full overflow-hidden leading-none ${className} ${position === 'top' ? 'rotate-180' : ''}`} data-id="element-196">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className={`relative block w-full h-[60px] sm:h-[100px] ${flip ? 'scale-x-[-1]' : ''}`} style={{
      fill: color
    }} data-id="element-197">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" data-id="element-198"></path>
      </svg>
    </div>;
}